export default "__VITE_ASSET__DqEPAxrx__"